export default {
  '关键字':'Keyword',
  '请输入名称关键字':'Enter name keyword',
  '新增计划':'Add Plan',
  '管理人员':'Administrator',
  '已选':'Selected',
  '清空':'Clear',
  '计划名称':'Plan Name',
  '个性化训练周期':'Personalized Training Cycle',
  '持续时长':'Duration',
  '天':'Day(s)',
  '个性化训练人数':'Personalized Training Participants',
  '是否删除':'Confirm Deletion',
  '删除后该计划不可再查看':'Deleted plans become inaccessible',
  '删除成功。':'Deleted successfully.',
  '是否提前结束':'Early Termination',
  '结束后立即生效':'Effective immediately after termination',
  '结束成功。':'Terminated successfully.',
  '操作成功。':'Operation succeeded.',
  '人员不能为空！':'Participants cannot be empty!',
  '请选择班级':'Select Class',

  '计划日期':'Plan Date',
  '运动日期':'Exercise Date',
  '学生姓名':'Student Name',
  '年级':'Grade',
  '强度':'Intensity',
  '个':'Unit(s)',
  '秒':'Second(s)',
  '填写基本信息':'Fill Basic Info',
  '配置运动项目':'Configure Sport Items',
  '发布个性化训练计划':'Publish Personalized Training Plan',
  '查看个性化训练计划':'View Personalized Training Plan',
  '编辑个性化训练计划':'Edit Personalized Training Plan',
  '请添加项目！':'Add Items Required!',
  '编辑成功':'Edited Successfully',
  '新增成功':'Added Successfully',
  '返回后数据不会保存':'Unsaved data will be lost',
  '基础信息':'Basic Information',
  '复制其他计划':'Copy Other Plan',
  '请选择':'Select',
  '请输入计划名称，1~20个字':'Plan Name (1-20 characters)',
  '选择图标':'Select Icon',
  '图标':'Icon',
  '参训人员':'Participants',
  '添加':'Add',
  '请输入描述':'Enter Description',
  '请输入计划名称':'Enter Plan Name',
  '请选择图标':'Select Icon',
  '请选择参训人员':'Select Participants',
  '配置项目':'Configure Items',
  '周期':'Cycle',
  '共计':'Total',
  '天':'Day(s)',
  '暂无':'No Data',
  '个项目':'Item(s)',
  '当前选中日期':'Selected Date',
  '添加项目':'Add Item',
  '复制其他日期':'Copy Other Date',
  '选择复制日期':'Select Date to Copy',
  '请选择日期':'Select Date',
  '选择项目':'Select Item',
  '运动方式':'Exercise Mode',
  '支持特殊项目':'Support Special Items',
  '分':'Minute(s)',
  '秒':'Second(s)',

  '请选择运动项目':'Select Sport Item',
  '请填写运动强度':'Enter Exercise Intensity',
  '运动强度填写错误':'Invalid Exercise Intensity',

  '项目名':'Item Name',
  '运动强度':'Exercise Intensity',
  '周一':'Mon',
  '周二':'Tue',
  '周三':'Wed',
  '周四':'Thu',
  '周五':'Fri',
  '周六':'Sat',
  '周日':'Sun',

  '请选择周期':'Select Cycle',
  '是否清空本日项目':'Clear Today\'s Items?',
  '所选日期没有数据！':'No data for selected date!',

  '用户列表':'User List',
  '未开始':'Have Not Started',
  '进行中':'Under Way',
  '已结束':'Have Finished',

  '确认要返回吗？':'Are you sure you want to return?!',
}